(function() {
  function parseVariants(root) {
    var el = root.querySelector('[data-scp-sticky-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function parsePriceMap(root) {
    var el = root.querySelector('[data-scp-sticky-prices]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function formatMoneyTL(cents, suffix) {
    var value = (Number(cents) || 0) / 100;
    var suffixText = suffix || ' TL';
    try {
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + suffixText;
    } catch (error) {
      return value.toFixed(2).replace('.', ',') + suffixText;
    }
  }

  function getSectionRoot(sectionId, root) {
    return document.querySelector('[data-section="' + sectionId + '"]') || root.closest('[data-section]');
  }

  function initStickyBuyBar(scope) {
    var roots = (scope || document).querySelectorAll('[data-scp-sticky-root]');
    roots.forEach(function(root) {
      if (root.dataset.scpStickyReady === 'true') return;
      root.dataset.scpStickyReady = 'true';

      // Sticky bar'in section wrapper etkilerinden cikmasi icin body altina tasiyoruz.
      if (root.dataset.scpMovedToBody !== 'true') {
        document.body.appendChild(root);
        root.dataset.scpMovedToBody = 'true';
      }

      var sectionId = root.dataset.sectionId;
      var sectionRoot = getSectionRoot(sectionId, root);
      if (!sectionRoot) return;

      var observeTarget = sectionRoot.querySelector('.product-form__buttons');
      var addSubmitButton = sectionRoot.querySelector('.product-form__submit');
      var dynamicBuyButton = sectionRoot.querySelector('.shopify-payment-button__button');
      var priceEl = root.querySelector('[data-scp-sticky-price]');
      var oldPriceEl = root.querySelector('[data-scp-sticky-old-price]');
      var badgeEl = root.querySelector('[data-scp-sticky-badge]');
      var titleEl = root.querySelector('[data-scp-sticky-title]');
      var imageEl = root.querySelector('[data-scp-sticky-image]');
      var addBtn = root.querySelector('[data-scp-sticky-add]');
      var buyBtn = root.querySelector('[data-scp-sticky-buy]');
      var variantIdInput = sectionRoot.querySelector('.product-variant-id');
      var variants = parseVariants(root);
      var prices = parsePriceMap(root);
      var showSavings = root.dataset.showSavings === 'true';
      var moneySuffix = root.dataset.moneySuffix || ' TL';

      function getCurrentVariant() {
        if (!variantIdInput || !variantIdInput.value) return null;
        var currentId = Number(variantIdInput.value);
        return variants.find(function(v) { return Number(v.id) === currentId; }) || null;
      }

      function updateStickyData() {
        var variant = getCurrentVariant();
        if (!variant) return;
        var priceInfo = prices.find(function(p) { return Number(p.id) === Number(variant.id); }) || null;

        if (titleEl) {
          titleEl.textContent = root.dataset.productTitle || variant.name || '';
        }

        if (priceEl) {
          priceEl.textContent = priceInfo && priceInfo.price_text
            ? (priceInfo.price_text + moneySuffix)
            : formatMoneyTL(variant.price, moneySuffix);
        }

        if (oldPriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            oldPriceEl.textContent = priceInfo && priceInfo.compare_at_text
              ? (priceInfo.compare_at_text + moneySuffix)
              : formatMoneyTL(variant.compare_at_price, moneySuffix);
            oldPriceEl.hidden = false;
          } else {
            oldPriceEl.hidden = true;
          }
        }

        if (badgeEl) {
          if (showSavings && variant.compare_at_price && variant.compare_at_price > variant.price) {
            var compareAt = Number(variant.compare_at_price) || 0;
            var percent = Math.floor(((compareAt - variant.price) * 100) / compareAt);
            badgeEl.textContent = '%' + percent + ' TASARRUF';
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }

        if (imageEl && variant.featured_image && variant.featured_image.src) {
          imageEl.src = variant.featured_image.src;
        }

        var soldOut = !variant.available;
        if (addBtn) addBtn.disabled = soldOut;
        if (buyBtn && dynamicBuyButton) {
          buyBtn.disabled = soldOut || dynamicBuyButton.disabled || dynamicBuyButton.getAttribute('aria-disabled') === 'true';
        }
      }

      function syncButtonStates() {
        if (addBtn && addSubmitButton) {
          addBtn.disabled = addSubmitButton.disabled;
        }
        if (buyBtn && dynamicBuyButton) {
          buyBtn.disabled = dynamicBuyButton.disabled || dynamicBuyButton.getAttribute('aria-disabled') === 'true';
        } else if (buyBtn && !dynamicBuyButton) {
          buyBtn.disabled = true;
        }
      }

      if (addBtn) {
        addBtn.addEventListener('click', function() {
          if (!addSubmitButton || addSubmitButton.disabled) return;
          addSubmitButton.click();
        });
      }

      if (buyBtn) {
        buyBtn.addEventListener('click', function() {
          if (!dynamicBuyButton) return;
          if (dynamicBuyButton.disabled || dynamicBuyButton.getAttribute('aria-disabled') === 'true') return;
          dynamicBuyButton.click();
        });
      }

      if (observeTarget) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              root.classList.remove('is-visible');
            } else {
              root.classList.add('is-visible');
            }
          });
        }, { threshold: 0.1 });
        observer.observe(observeTarget);
      }

      var updateTimer = window.setInterval(function() {
        updateStickyData();
        syncButtonStates();
      }, 450);

      root.addEventListener('remove', function() {
        window.clearInterval(updateTimer);
      });

      document.addEventListener('change', function(event) {
        if (!event.target.closest('variant-selects') && !event.target.closest('variant-radios')) return;
        window.setTimeout(function() {
          updateStickyData();
          syncButtonStates();
        }, 150);
      });

      updateStickyData();
      syncButtonStates();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initStickyBuyBar(document);
    });
  } else {
    initStickyBuyBar(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initStickyBuyBar(event.target);
  });
})();
